import { Component, OnInit, ViewEncapsulation, SimpleChanges } from '@angular/core';

import { Observable } from 'rxjs';

import { BaseVraagControlDirective } from '../base/base-vraag-control';
import { Vraag, Antwoord } from '@models/claims';
import { SharedData } from '@models/shareddata';
import { IBaseVraagboomResultaat, SchademeldenState, VraagboomAntwoord, VraagboomEmptyResultaat } from '@models/vragenboom';
import { DataService } from '../../../services/data.service';
import { SharedDataService } from '@services/public_api';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-msm',
  templateUrl: './mobielschademelden.component.html',
  styleUrls: ['./mobielschademelden.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class MobielSchadeMeldenComponent extends BaseVraagControlDirective<VraagboomEmptyResultaat> implements OnInit {
  vraagtitel: string;
  status: SchademeldenState;
  button_text1: string;
  button_text2: string;
  resultaten$: Observable<VraagboomAntwoord<IBaseVraagboomResultaat>[]>;
  teksten: SharedData[];
  popupTitel: string;
  popupTekst: string;
  popupButtonTekst: string;
  popupImage: string;

  constructor(
    _dataService: DataService,
    private _sharedDataService: SharedDataService) {
    super(_dataService);
  }

  ngOnInit() {
    if (this.vraag?.titel?.length > 0) {
      this.vraagtitel = this.vraag.titel;
    }
    if (this.vraag?.button_text?.length > 0) {
      var text = this.vraag.button_text.split('|');
      if (text.length > 1) {
        this.button_text1 = text[0];
        if (text.length > 1) {
          this.button_text2 = text[1];
        }
      }
    }

    this._sharedDataService.getTeksten().pipe(takeUntil(this.unsubscribe$))
      .subscribe((teksten: SharedData[]) => {
        this.teksten = teksten;
        this.popupTitel = this.geefTekst('msmPopupTitel');
        this.popupTekst = this.geefTekst('msmPopupTekst');
        this.popupButtonTekst = this.geefTekst('msmPopupButtonTekst');
        this.popupImage = this.geefTekst('msmPopupImage');

        window.dispatchEvent(new Event("msmpopup:klaar"));
      });
  }

  initialize(changes: SimpleChanges): void { }

  geefTekst(name: string): string {
    return this.teksten ? this.teksten.find(t => t.Name === name)?.Phrase : '';
  }

  validate(vraag: Vraag, antwoorden: Antwoord[], resultaat: VraagboomEmptyResultaat): boolean {
    return true;
  }

  eindeVerzekeringkiezer(): void {
    this.setAntwoord(this.vraag.antwoorden, new VraagboomEmptyResultaat());
  }

  geefPazaProces(): string {
    return this._dataService.getMeetidPazaProces();
  }
}
